import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

interface BreadCrumb2Props {
  title: string;
  pageTitle: string;
  link?: string;
  linkId?: string;
}

const BreadCrumb2 = ({
  title,
  pageTitle,
  link = '#',
  linkId = '',
}: BreadCrumb2Props) => {
  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div
            className="page-title-box d-sm-flex align-items-center justify-content-between"
            data-testid="breadcrumb-ele"
          >
            <h4 className="mb-sm-0" data-testid="bc-h4-title">
              {title}
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to={link} id={linkId}>
                    {' '}
                    <span style={{ color: '#4bb189' }}>{pageTitle}</span>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  data-testid="bc-li-title"
                >
                  {title}
                </li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default BreadCrumb2;
